import { Modal, Button as AntButton } from "antd";
import { useTranslation } from "react-i18next";
import Radio from "../../../Radio";
import { useEffect, useState } from "react";
import { ITreeSubcode, IAddTreeSubCodeReq } from "../../../../models/treeCodes.model";

interface IProps {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    isEdit: boolean;
    actionTreeLevel: number;
    selSubCodeData?: ITreeSubcode;
    selFirstCodeData?: ITreeSubcode;
    selSecondCodeData?: ITreeSubcode;
    onCreate: (data: IAddTreeSubCodeReq) => void;
    onUpdate: (data: IAddTreeSubCodeReq) => void;
}

const TreeCodeEditModal = ({visible, setVisible, isEdit, actionTreeLevel, selSubCodeData, selFirstCodeData, selSecondCodeData, onCreate, onUpdate} : IProps) => {
    const { t, i18n } = useTranslation();
    const [treeId, setTreeId] = useState('');
    const [codeKorName, setCodeKorName] = useState('');
    const [codeEngName, setCodeEngName] = useState('');
    const [useYN, setUseYN] = useState('Y');
    const [treeIdHier, setTreeIdHier] = useState('');

    useEffect(() => {
        if(isEdit && selSubCodeData) {
            setTreeId(selSubCodeData.treeId);
            setCodeKorName(selSubCodeData.korName);
            setCodeEngName(selSubCodeData.engName);
            setUseYN(selSubCodeData.useYn);
            setTreeIdHier(selSubCodeData.treeIdHier);
        } else if(!isEdit) {
            if(actionTreeLevel === 2 && selFirstCodeData) {
                setTreeIdHier(selFirstCodeData.treeIdHier);
            } else if(actionTreeLevel === 3 && selSecondCodeData) {
                setTreeIdHier(selSecondCodeData.treeIdHier);
            }
        }
    }, []);

    const onSubmit = () => {
        //유효성 체크
        const treeSubCodeReq : IAddTreeSubCodeReq = {
            detailCode : 0,
            parentDetailCode : 0,
            treeId : treeId,
            korName : codeKorName,
            engName : codeEngName,
            commonCode : 'common',
            useYn : useYN,
            treeLevel : actionTreeLevel
        };

        if(isEdit && selSubCodeData) {
            //수정
            treeSubCodeReq.detailCode = selSubCodeData.detailCode;
            treeSubCodeReq.parentDetailCode = selSubCodeData.parentDetailCode;
            treeSubCodeReq.commonCode = selSubCodeData.commonCode;
            //treeSubCodeReq.treeIdHier = selSubCodeData.treeIdHier

            let editTreeIdHier = actionTreeLevel + '|' + treeId;

            if(actionTreeLevel === 2) {
                if(selFirstCodeData) {
                    editTreeIdHier = selFirstCodeData.treeIdHier + '-' + actionTreeLevel + '|' + treeId;
                }
            } else if(actionTreeLevel === 3) {
                if(selSecondCodeData) {
                    editTreeIdHier = selSecondCodeData.treeIdHier + '-' + actionTreeLevel + '|' + treeId;
                }
            }
            treeSubCodeReq.treeIdHier = editTreeIdHier;

            onUpdate(treeSubCodeReq);
        } else {
            //추가
            let addTreeIdHier = treeId;
            let parentDetailCode = 0;
            
            if(actionTreeLevel === 2) {
                if(selFirstCodeData) {
                    addTreeIdHier = selFirstCodeData.treeIdHier + '-' + actionTreeLevel + '|' + treeId;
                    parentDetailCode = selFirstCodeData.detailCode;
                }
            } else if(actionTreeLevel === 3) {
                if(selSecondCodeData) {
                    addTreeIdHier = selSecondCodeData.treeIdHier + '-' + actionTreeLevel + '|' + treeId;
                    parentDetailCode = selSecondCodeData.detailCode;
                }
            }
            treeSubCodeReq.treeIdHier = addTreeIdHier;
            treeSubCodeReq.parentDetailCode = parentDetailCode;

            onCreate(treeSubCodeReq);
        }
    }

    const onClose = () => {
        setVisible(false);
    };

    const handleInputChange = (e: any) => {
        const value = e.target.value;
        // 영어 알파벳 (대문자/소문자)와 숫자만 허용하는 정규식
        const regex = /^[a-zA-Z0-9]*$/;
    
        if (regex.test(value) && value.length <= 5) {
            setTreeId(value);
        }
    };

    return (
        <>
            <Modal
                title={t('program.criteria.title2')}
                visible={visible}
                onCancel={onClose}
                footer={[
                    <div className='comm-btn__area justify-content-center'>
                    <AntButton
                        key="submit"
                        className='btn-basic pink'
                        onClick={onSubmit}
                    >
                        {t('common.button.save')}
                    </AntButton>
                    <AntButton
                        key="cancel"
                        className='btn-basic gray'
                        onClick={onClose}
                    >
                        {t('common.button.cancel')}
                    </AntButton>
                    </div>
                ]}>
                <div className="comm-table__area rowType mt-0">
                    <table>
                        <tbody>
                            {actionTreeLevel > 1 &&
                                <tr>
                                    <th>{t('system.treecode.column2')}</th>
                                    <td>
                                        <input
                                            disabled={true}
                                            type="text"
                                            className="form-control input-text"
                                            value={treeIdHier}
                                    /></td>
                                </tr>
                            }
                            <tr>
                                <th>{t('system.code.column1')}</th>
                                <td>
                                    <input
                                        //disabled={disabled}
                                        type="text"
                                        className="form-control input-text"
                                        value={treeId}
                                        onChange={(e) => handleInputChange(e)}
                                /></td>
                            </tr>
                            <tr>
                                <th>{t('system.treecode.column1') + '('+ t('system.locale.column3') + ')'}</th>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control input-text"
                                        value={codeKorName}
                                        onChange={(e) => setCodeKorName(e.target.value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('system.treecode.column1') + '('+ t('system.locale.column4') + ')'}</th>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control input-text"
                                        value={codeEngName}
                                        onChange={(e) => setCodeEngName(e.target.value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('system.code.column4')}</th>
                                <td>
                                    <Radio
                                        checked={useYN === 'Y'}
                                        onChange={() => setUseYN('Y')}
                                        text={t('common.option.yes')}
                                    />
                                    <Radio
                                        className="ml-4"
                                        checked={useYN === 'N'}
                                        onChange={() => setUseYN('N')}
                                        text={t('common.option.no')}
                                    />

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Modal>
        </>
    )
}

export default TreeCodeEditModal;